import { createReducer } from 'app-webtech-core/reducers/createReducer';
import {
  SET_APP_INFO,
  SET_LAUNCH_STATE,
  SETUP,
  FEATURE_DISCOVERY,
  SET_FOCUSED_AREA,
  SET_SESSION_TOKEN,
  DISMISS_GET_APP_BANNER,
  BOOTSTRAP_RESTART_REQUEST,
  BUFFER_EVENTS,
} from '../actions/types';
import { applicationSetupReducer } from './setup';
import { LAUNCH_STATE, FOCUSED_AREA } from '../constants';
import { applicationLaunchStateReducer } from './launchState';
import { applicationAppInfoReducer } from './appInfo';
import { applicationFeatureDiscoveryReducer } from './featureDiscovery';
import { applicationFocusedAreaReducer } from './focusedArea';
import { appliactionSessionTokenReducer } from './sessionToken';
import { applicationDismissGetAppBannerReducer } from './dismissGetAppBanner';
import { applicationBootstrapRestartRequestReducer } from './refreshToken';
import { applicationBufferEventsReducer } from './bufferEvents';

export const defaultState = {
  isConfigured: false,
  launchState: LAUNCH_STATE.INITIALIZING,
  featureDiscovery: 0,
  getAppBannerDismissed: false,
  focusedArea: FOCUSED_AREA.SCHEDULE_LINES,
  sessionToken: false,
  refreshingToken: false,
  bufferEvents: false,
};

export const applicationReducer = createReducer(defaultState, {
  [SETUP]: applicationSetupReducer,
  [SET_LAUNCH_STATE]: applicationLaunchStateReducer,
  [SET_FOCUSED_AREA]: applicationFocusedAreaReducer,
  [SET_APP_INFO]: applicationAppInfoReducer,
  [FEATURE_DISCOVERY]: applicationFeatureDiscoveryReducer,
  [SET_SESSION_TOKEN]: appliactionSessionTokenReducer,
  [DISMISS_GET_APP_BANNER]: applicationDismissGetAppBannerReducer,
  [BOOTSTRAP_RESTART_REQUEST]: applicationBootstrapRestartRequestReducer,
  [BUFFER_EVENTS]: applicationBufferEventsReducer,
});
